import React from "react";
import PropTypes from "prop-types";
import Box from "@material-ui/core/Box";

function ElementsInLine({elements, spaced, width, start, pt, pb, alignItems}) {
    return <Box display="flex"
                flexDirection="row"
                pt={pt ? pt : 0}
                pb={pb ? pt : 0}
                alignContent={"flex-end"}
                alignItems={alignItems ? alignItems : "center"}
                justifyContent={spaced ? "space-between" : start ? "flex-start" : "flex-end"}
                style={width ? {width: width} : {width: "100%"}}
    >
        {elements.map((element, index) => (
            <Box pt={pt} pb={pb}  key={index}>{element}</Box>))}
    </Box>;
}

ElementsInLine.propTypes = {
    elements: PropTypes.arrayOf(PropTypes.object).isRequired,
    spaced: PropTypes.bool,
    start: PropTypes.bool,
    width: PropTypes.number,
    pt: PropTypes.number
};

export default ElementsInLine;